import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY || document.documentElement.scrollTop;
      if (!menuOpen) {
        setScrolled(scrollY > 20);
      }
    };

    window.addEventListener("scroll", handleScroll);
    document.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("scroll", handleScroll);
    };
  }, [menuOpen]); // 👈 now menuOpen is a dependency

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "auto";

    if (menuOpen) {
      setScrolled(false); // 👈 ensures navbar expands fully during menu open
    }
  }, [menuOpen]);

  return (
    <>
      <nav className={` navbar ${scrolled ? "scrolled" : ""}`}>
        <div className="logo">George S.</div>

        <ul className={`nav-links ${menuOpen ? "active" : ""}`}>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/portfolio"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Portfolio
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/personal"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              Personal
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) =>
                `nav-link ${isActive ? "active" : ""}`
              }
              onClick={() => setMenuOpen(false)}
            >
              About me
            </NavLink>
          </li>
        </ul>

        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <div></div>
          <div></div>
          <div></div>
        </div>
      </nav>

      {/* Fullscreen overlay behind mobile nav */}
      <div
        className={`mobile-overlay ${menuOpen ? "visible" : ""}`}
        onClick={() => setMenuOpen(false)}
      ></div>
    </>
  );
}
